module.exports = "/images/siteActivationChecklist.svg?ae050617140ac8203fbcb596e5776098";